import React from "react";
import { toast } from "react-toastify";
import { Button, DynamicDropdown, Form, TextInput } from "src/Components";
import {
  getPortfolioGroupDropDown,
  upsertGroupingSettingsUserAllowedCreditPercent,
  upsertUserPortfoGroup,
} from "src/Requests/portfolioGroups";
import type { IUserPortfoGroupTableReport } from "src/Interfaces/portfolioGroups";
import { packetErrorHandler } from "src/Utils/requestUtils";
import { getPercent } from "src/helper";

const NO_GROUP_ID = -1;

interface IProps {
  row: IUserPortfoGroupTableReport;
  onClose: () => void;
  onSuccess: () => void;
}

const EditAssignmentModal: React.FC<IProps> = ({ row, onClose, onSuccess }) => {
  const [loading, setLoading] = React.useState(false);
  const [portfolioGroupId, setPortfolioGroupId] = React.useState<
    number | string | undefined
  >(row.groupId ?? NO_GROUP_ID);
  const [allowedCreditPercent, setAllowedCreditPercent] =
    React.useState<string>(
      row.allowedCreditPercent != null ? row.allowedCreditPercent.toString() : "",
    );

  const submitHandler = () => {
    const groupId = Number(portfolioGroupId);
    if (Number.isNaN(groupId)) {
      toast.error("گروه پرتفو را انتخاب کنید");
      return;
    }

    const hasAllowedCreditPercent = allowedCreditPercent !== "";
    const parsedAllowedCreditPercent = hasAllowedCreditPercent
      ? getPercent(allowedCreditPercent)
      : null;

    if (hasAllowedCreditPercent && parsedAllowedCreditPercent == null) {
      toast.error("درصد اعتبار مجاز را وارد کنید");
      return;
    }

    setLoading(true);
    upsertUserPortfoGroup({
      sahraUserId: row.id,
      portfoGroupId: groupId,
    })
      .then(async (resp) => {
        if (!resp.data) {
          toast.error(resp.msg);
          return;
        }

        if (parsedAllowedCreditPercent != null) {
          const creditResponse =
            await upsertGroupingSettingsUserAllowedCreditPercent({
              sahraUserId: row.id,
              value: Number(parsedAllowedCreditPercent),
            });
          if (!creditResponse.data) {
            toast.error(creditResponse.msg);
            return;
          }
        }

        toast.success(resp.msg);
        onSuccess();
        onClose();
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  return (
    <Form className="p-4 gap-4 !w-72">
      <TextInput
        label="اکانت"
        name="accountName"
        value={row.accountName ?? ""}
        onChange={() => undefined}
        readOnly
        extraLabel
      />
      <DynamicDropdown
        dropdown={{
          name: "portfolioGroupId",
          placeholder: "گروه پرتفو",
          extraLabel: true,
        }}
        getData={getPortfolioGroupDropDown}
        onChange={(_, value) => setPortfolioGroupId(value)}
        value={portfolioGroupId?.toString()}
      />
      <TextInput
        label="درصد اعتبار مجاز"
        name="allowedCreditPercent"
        value={allowedCreditPercent}
        onChange={(_, value) => setAllowedCreditPercent(value ?? "")}
        kind="percent"
        extraLabel
      />
      <Button
        text="ثبت"
        variant="contained"
        onClick={submitHandler}
        loading={loading}
      />
    </Form>
  );
};

export default EditAssignmentModal;
